import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../contexts/AuthContext';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import RegisterWithInvite from './RegisterWithInvite';
import './Auth.css';

function Register() {
  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get('invite');

  // If there's an invite code, render the invite registration flow
  if (inviteCode) {
    return <RegisterWithInvite />;
  }

  return <StandardRegister />;
}

function StandardRegister() {
  const { t } = useTranslation();
  const [userData, setUserData] = useState({
    email: '',
    password: '',
    first_name: '',
  });
  const [error, setError] = useState('');
  const { register } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await register(userData);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || t('auth.registrationFailed'));
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{t('auth.registerTitle')}</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('auth.email')} *</label>
            <input
              type="email"
              value={userData.email}
              onChange={(e) => setUserData({ ...userData, email: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label>{t('auth.password')} *</label>
            <input
              type="password"
              value={userData.password}
              onChange={(e) => setUserData({ ...userData, password: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label>{t('auth.firstName')}</label>
            <input
              type="text"
              value={userData.first_name}
              onChange={(e) => setUserData({ ...userData, first_name: e.target.value })}
              placeholder={t('common.optional')}
            />
          </div>
          <button type="submit" className="btn btn-primary">{t('auth.register')}</button>
        </form>
        <p className="auth-link">
          {t('auth.hasAccount')} <Link to="/login">{t('auth.loginHere')}</Link>
        </p>
      </div>
    </div>
  );
}

export default Register;
